<template>
		<div>
				<md-card>
						<div style="height: 7px;">
								<md-progress-bar v-show="loading" md-mode="query"></md-progress-bar>
						</div>

						<md-card-header>
								<h3 style="margin-top: 0;">Редактирование темы / заявка {{dataObj.ticket.number}}</h3>
						</md-card-header>

						<md-card-content>
								<div style="min-width: 600px">
										<md-field md-clearable>
												<label for="title">Тема заявки</label>
												<md-input type="text" placeholder="Введите тему заявки" v-model.trim="title" id="title"/>
										</md-field>
								</div>
						</md-card-content>

						<md-card-actions>
								<md-button class="md-dense md-primary"
								           :disabled="!title || title === dataObj.ticket.title"
								           @click="save(dataObj.ticket.npp, title)"
								>
										Сохранить
								</md-button>
								<md-button class="md-dense md-accent" @click="cancel">Отмена</md-button>
						</md-card-actions>
				</md-card>
		</div>
</template>

<script>
	export default {
		name: "titleWindow",
		data: () => ({
			title: '',
			loading: false
		}),
		props: ['dataObj'],
		methods: {
			async save(ticketNpp, newTitle) {
				try {
					this.loading = true;
					const response = await this.$http.put("data/SetNewTicketTitle", {ticketNpp, newTitle}, {emulateJSON: true});
					if (response.body.statusCode > 200) {
						await this.$store.dispatch("showSnackBar", {snackText: `Произошла ошибка при изменении темы! ${response.body.reasonPhrase}`});
						console.error(response.body.reasonPhrase);
						return;
					}
					await this.$store.dispatch("showSnackBar", {snackText: `Тема изменена`});
					this.$emit("closeTitleWindow", this.title);
				} catch (error) {
					console.error(error);
					await this.$store.dispatch("showSnackBar", {snackText: `Произошла ошибка при изменении темы! ${error.message}`});
				} finally {
					this.loading = false;
				}
			},
			cancel() {
				this.$emit("closeTitleWindow");
			}
		},
		mounted() {
			this.title = this.dataObj.ticket.title || '';
		}
	}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// Components/supportNew/titleWindow.vue